angular.module('picmonicng').controller('MySubscriptionsPaymentInfoController', [
  '$scope',
  'User',
  'UserService',
  'ReplaceCardModal',
  '$stateParams',
  function ($scope, User, UserService, ReplaceCardModal, $stateParams) {
    $scope.loading = true;
    $scope.UserService = UserService;
    User.payment_info(function (data) {
      $scope.credit_card = data;
      $scope.loading = false;
    });

    $scope.changePaymentInfo = function () {
      modal = ReplaceCardModal.show();
      modal.result.then(function () {
        $scope.loading = true;
        User.payment_info(function (data) {
          $scope.credit_card = data;
          $scope.loading = false;
        });
      });
    };

    if ($stateParams.replace) {
      $scope.changePaymentInfo();
    }
  },
]);
